var context = {
    selectedProducts: [], // products picked for step A
    selectedSmells: {}, //scents picked for step B
    quizAnswerBoughtBefore: '', //holds the value of the answer on slide 00a
    quizGeneratedResults: [],
    step: '',
    email: '',
    products: [
      {
        id: 1,
        name: "Tobacco Vanille",
        vendor: "Tom Ford",
        dossierCorrespondent: "POWDERY TOBACCO",
        dossierProductId: 8076774605026,
        display: true,
        selected: false,
        similarProductIds: ["woody-tobacco"],
        rank: 87,
      },
      {
        id: 3,
        name: "Light Blue F",
        vendor: "Dolce & Gabbana",
        dossierCorrespondent: "CITRUS GREEN APPLE",
        dossierProductId: "citrus-green-apple",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Dolce_Gabbana_-_Light_Blue_w_9734b251-55d3-49cc-8211-58fc555dfa85.png",
        display: true,
        selected: false,
        similarProductIds: ["fruity-magnolia"],
        rank: 16,
      },
      {
        id: 4,
        name: "Bright Crystal",
        vendor: "Versace",
        dossierCorrespondent: "FRUITY MAGNOLIA",
        dossierProductId: 'fruity-magnolia',
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Versace_-_Bright_Crystal_04335fb4-7438-4185-b9ba-714d05fffd0e.png",
        display: true,
        selected: false,
        similarProductIds: ["citrus-green-apple"],
        rank: 23,
      },
      {
        id: 6,
        name: "Chance Eau Tendre",
        vendor: "Chanel",
        dossierCorrespondent: "FLORAL GRAPEFRUIT",
        dossierProductId: 8076773982434,
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Chanel_-_Chance_Eau_Tendre_3c6ea0e8-8a49-488b-b7b1-f366a0a56858.png",
        display: true,
        selected: false,
        similarProductIds: ["floral-violet"],
        rank: 25,
      },
      {
        id: 7,
        name: "Daisy",
        vendor: "Marc Jacobs",
        dossierCorrespondent: "FLORAL VIOLET",
        dossierProductId: 8076774146274,
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Marc_Jacobs_-_Daisy_e900fc44-4a34-4342-96ef-bea602752161.png",
        display: true,
        selected: false,
        similarProductIds: ["floral-grapefruit"],
        rank: 20,
      },
      {
        id: 15,
        name: "Rose 31",
        vendor: "Le Labo",
        dossierCorrespondent: "FLORAL ROSE",
        dossierProductId: 8076774113506,
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Le_Labo_-_Rose_31_957be971-320d-4f3f-815a-a9eac32099e6.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 42,
      },
      {
        id: 20,
        name: "Bloom",
        vendor: "Gucci",
        dossierProductId: 8076774015202,
        dossierCorrespondent: "FLORAL HONEYSUCKLE",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Gucci_-_Bloom.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 18,
      },
      {
        id: 22,
        name: "Chance",
        vendor: "Chanel",
        dossierProductId: 8076774768866,
        dossierCorrespondent: "WOODY HYACINTH",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Chanel_-_Chance.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 31,
      },
      {
        id: 23,
        name: "Coco Mademoiselle",
        vendor: "Chanel",
        dossierProductId: 8076774801634,
        dossierCorrespondent: "WOODY OAKMOSS",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Chanel_-_Coco_Mademoiselle.png",
        display: true,
        selected: false,
        similarProductIds: ["woody-hyacinth"],
        rank: 87,
      },
      {
        id: 25,
        name: "My Way",
        vendor: "Giorgio Armani",
        dossierProductId: "fruity-neroli",
        dossierCorrespondent: "FRUITY NEROLI",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Giorgio_Armani_-_My_Way.png",
        display: true,
        selected: false,
        similarProductIds: ["floral-marshmallow","floral-lavender"],
        rank: 46,
      },
      {
        id: 26,
        name: "Love, don't be shy ",
        vendor: "By Kilian",
        dossierProductId: "floral-marshmallow",
        dossierCorrespondent: "FLORAL MARSHMALLOW",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/By_killian_-_Love_don_t_be_shy.png",
        display: true,
        selected: false,
        similarProductIds: ["fruity-neroli","floral-lavender"],
        rank: 87,
      },
      {
        id: 28,
        name: "Libre",
        vendor: "YSL",
        dossierProductId: "floral-lavender",
        dossierCorrespondent: "FLORAL LAVENDER",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/YSL_-_Libre.png",
        display: true,
        selected: false,
        similarProductIds: ["fruity-neroli","floral-marshmallow"],
        rank: 9,
      },
      {
        id: 29,
        name: "Good Girl",
        vendor: "Carolina Herrera",
        dossierProductId: 8076774211810,
        dossierCorrespondent: "FRUITY ALMOND",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Carolina_Herrera_-_Good_Girl.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 87,
      },
      {
        id: 34,
        name: "Flower Bomb",
        vendor: "Viktor & Rolf",
        dossierProductId: "gourmand-white-flowers",
        dossierCorrespondent: "GOURMAND WHITE FLOWERS",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Viktor_Rolf_-_Flowerbomb.png",
        display: true,
        selected: false,
        similarProductIds: ["ambery-vanilla","gourmand-orange-blossom"],
        rank: 5,
      },
      {
        id: 36,
        name: "Black Opium",
        vendor: "YSL",
        dossierProductId: "ambery-vanilla",
        dossierCorrespondent: "AMBERY VANILLA",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/YSL_-_Black_Opium.png",
        display: true,
        selected: false,
        similarProductIds: ["gourmand-white-flowers","gourmand-orange-blossom"],
        rank: 87,
      },
      {
        id: 37,
        name: "La Vie est Belle",
        vendor: "Lancome",
        dossierProductId: "gourmand-orange-blossom",
        dossierCorrespondent: "GOURMAND ORANGE BLOSSOM",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Lancome_-_La_Vie_est_Belle.png",
        display: true,
        selected: false,
        similarProductIds: ["gourmand-white-flowers","ambery-vanilla"],
        rank: 27,
      },
      {
        id: 39,
        name: "J'adore",
        vendor: "Dior",
        dossierProductId: "fruity-jasmine",
        dossierCorrespondent: "FRUITY JASMINE",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Dior_-_J_adore.png",
        display: true,
        selected: false,
        similarProductIds: [],
        recommendedProductIds: [],
        rank: 19,
      },
      {
        id: 45,
        name: "Silver Mountain Water",
        vendor: "Creed",
        dossierProductId: "musky-green-tea",
        dossierCorrespondent: "MUSKY GREEN TEA",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Creed_-_Silver_Mountain_Water.png",
        display: true,
        selected: false,
        similarProductIds: ["woody-sage","citrus-tea"],
        rank: 36,
      },
      {
        id: 46,
        name: "Wood Sage & Sea Salt",
        vendor: "Jo Malone ",
        dossierProductId: "woody-sage",
        dossierCorrespondent: "WOODY SAGE",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Jo_Malone_-_Wood_Sage_Sea_Salt.png",
        display: true,
        selected: false,
        similarProductIds: ["musky-green-tea","citrus-tea"],
        rank: 7,
      },
      {
        id: 47,
        name: "Thé Noir 29 ",
        vendor: "Le Labo",
        dossierProductId: "citrus-tea",
        dossierCorrespondent: "CITRUS TEA",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Le_Labo_-_The_Noir_29.png",
        display: true,
        selected: false,
        similarProductIds: ["musky-green-tea","woody-sage"],
        rank: 37,
      },
      {
        id: 50,
        name: "Nectarine Blossom & Honey",
        vendor: "Jo Malone",
        dossierProductId: "fruity-honey",
        dossierCorrespondent: "FRUITY HONEY",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Jo_Malone_-_Nectarine_Blossom_Honey.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 24,
      },
      {
        id: 52,
        name: "Soleil Blanc",
        vendor: "Tom Ford ",
        dossierProductId: "powdery-coconut",
        dossierCorrespondent: "POWDERY COCONUT",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Tom_Ford_-_Soleil_Blanc.png",
        display: true,
        selected: false,
        similarProductIds: ["spicy-orchid","ambery-cedarwood"],
        rank: 87,
      },
      {
        id: 53,
        name: "Black Orchid",
        vendor: "Tom ford ",
        dossierProductId: "spicy-orchid",
        dossierCorrespondent: "SPICY ORCHID",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Tom_Ford_-_Black_Orchid.png",
        display: true,
        selected: false,
        similarProductIds: ["powdery-coconut","ambery-cedarwood"],
        rank: 29,
      },
      {
        id: 55,
        name: "Alien",
        vendor: "Thierry Mugler",
        dossierProductId: "ambery-cedarwood",
        dossierCorrespondent: "AMBERY CEDARWOOD",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Thierry_Mugler_-_Alien.png",
        display: true,
        selected: false,
        similarProductIds: ["powdery-coconut","spicy-orchid"],
        rank: 87,
      },
      {
        id: 56,
        name: "Replica Jazz Club ",
        vendor: "Maison Margiela",
        dossierProductId: "woody-tobacco",
        dossierCorrespondent: "WOODY TOBACCO",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Maison_Margiela_-_Replica_Jazz_Club.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 32,
      },
      {
        id: 58,
        name: "Baccarat Rouge 540",
        vendor: "MFK",
        dossierProductId: "ambery-saffron",
        dossierCorrespondent: "AMBERY SAFFRON",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/MFK_-_Baccarat_Rouge_540.png",
        display: true,
        selected: false,
        similarProductIds: ["woody-chestnut","ambery-sage","woody-sandalwood"],
        rank: 1,
      },
      {
        id: 60,
        name: "Replica by the Fireplace ",
        vendor: "Maison Margiela",
        dossierProductId: "woody-chestnut",
        dossierCorrespondent: "WOODY CHESTNUT",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Maison_Margiela_-_Replica_By_the_Fireplace.png",
        display: true,
        selected: false,
        similarProductIds: ["ambery-saffron","ambery-sage","woody-sandalwood"],
        rank: 26,
      },
      {
        id: 61,
        name: "Fucking Fabulous",
        vendor: "Tom Ford",
        dossierProductId: "ambery-sage",
        dossierCorrespondent: "AMBERY SAGE",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Tom_Ford_-_Fucking_Fabulous.png",
        display: true,
        selected: false,
        similarProductIds: ["ambery-saffron","woody-chestnut","woody-sandalwood"],
        rank: 87,
      },
      {
        id: 63,
        name: "Santal 33",
        vendor: "Le Labo",
        dossierProductId: "woody-sandalwood",
        dossierCorrespondent: "WOODY SANDALWOOD",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Le_Labo_-_Santal_33.png",
        display: true,
        selected: false,
        similarProductIds: ["ambery-saffron","woody-chestnut","ambery-sage"],
        rank: 4,
      },
      {
        id: 64,
        name: "Lost Cherry",
        vendor: "Tom Ford",
        dossierProductId: 8076773523682,
        dossierCorrespondent: "AMBERY CHERRY",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Tom_Ford_-_Lost_Cherry.png",
        display: true,
        selected: false,
        similarProductIds: [],
        recommendedProductIds: ["woody-chestnut"],
        rank: 87,
      },
      {
        id: 65,
        name: "Not a perfume",
        vendor: "Juliette has a gun",
        dossierProductId: 8076774506722,
        dossierCorrespondent: "MUSKY MUSK",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Juliette_has_A_Gun_-_Not_a_Perfume.png",
        display: true,
        selected: false,
        similarProductIds: [],
        recommendedProductIds: [],
        rank: 14,
      },
      {
        id: 67,
        name: "Acqua di Gio",
        vendor: "Giorgio Armani",
        dossierProductId: 8076773687522,
        dossierCorrespondent: "AQUATIC LIME",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Giorgio_Armani_-_Acqua_di_Gio.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 41,
      },
      {
        id: 71,
        name: "Bleu de Chanel",
        vendor: "Chanel",
        dossierProductId: "citrus-ginger",
        dossierCorrespondent: "CITRUS GINGER",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Chanel_-_Bleu_de_Chanel.png",
        display: true,
        selected: false,
        similarProductIds: ["aromatic-star-anise","aromatic-pineapple"],
        rank: 15,
      },
      {
        id: 72,
        name: "Sauvage",
        vendor: "Dior",
        dossierProductId: "aromatic-star-anise",
        dossierCorrespondent: "AROMATIC STAR ANISE",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Dior_-_Sauvage.png",
        display: true,
        selected: false,
        similarProductIds: ["citrus-ginger","aromatic-pineapple"],
        rank: 11,
      },
      {
        id: 73,
        name: "Y",
        vendor: "YSL",
        dossierProductId: "aromatic-pineapple",
        dossierCorrespondent: "AROMATIC PINEAPPLE",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/YSL_-_YSL_Y.png",
        display: true,
        selected: false,
        similarProductIds: ["citrus-ginger","aromatic-star-anise"],
        rank: 28,
      },
      {
        id: 76,
        name: "Oud",
        vendor: "Tom Ford",
        dossierProductId: 8076774179042,
        dossierCorrespondent: "FOUGERE OUD",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Tom_Ford_-_Oud_Wood.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 38,
      },
      {
        id: 80,
        name: "Aventus",
        vendor: "Creed",
        dossierProductId: 8076774539490,
        dossierCorrespondent: "MUSKY OAKMOSS",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Creed_-_Aventus.png",
        display: true,
        selected: false,
        similarProductIds: [],
        rank: 13,
      },
      {
        id: 81,
        name: "One Million",
        vendor: "Paco Rabanne",
        dossierProductId: "woody-green-apple",
        dossierCorrespondent: "WOODY GREEN APPLE",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Paco_Rabanne_-_One_Million.png",
        display: true,
        selected: false,
        similarProductIds: ["ambery-mint"],
        rank: 58,
      },
      {
        id: 84,
        name: "Eros",
        vendor: "Versace",
        dossierProductId: "ambery-mint",
        dossierCorrespondent: "AMBERY MINT",
        imageUrl: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Versace_-_Eros.png",
        display: true,
        selected: false,
        similarProductIds: ["woody-green-apple"],
        rank: 45,
      }
    ],
  };